module.exports = __webpack_public_path__ + "static/material-snackbar-0fe0d7a16be9023cb643c799b22acb43.png";